// extracted by mini-css-extract-plugin
export var indeterminate = "_3t-6";
export var md = "_3t-5";
export var semantic = "_3t-7";
export var sm = "_3t-4";
export var text = "_3t-8";
export var toggleControl = "_3t-0";
export var toggleInput = "_3t-1";
export var toggleSwitch = "_3t-2";
export var xs = "_3t-3";